import { render, staticRenderFns } from "./viewHeading.vue?vue&type=template&id=97e957fc&scoped=true&"
import script from "./viewHeading.vue?vue&type=script&lang=js&"
export * from "./viewHeading.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "97e957fc",
  null
  
)

export default component.exports